import React from "react";
import { StatCard } from "../../../components/Drawer";
import { num } from "../PlatformDashboard";
import { T_CATEGORY } from "./supportUtil";

export function SupportStats({ s, onPick }) {
  if (!s) return null;
  const cards = [["Aktif", s.active, "support-stat-active", "active"], ["Belum ditugaskan", s.unassigned, "support-stat-unassigned", "queue"], ["Eskalasi L2", s.escalated, "support-stat-escalated", "escalated"], ["Tiket saya", s.mine, "support-stat-mine", "mine"], ["Belum dibaca", s.unread, "support-stat-unread", "active"], ["Selesai hari ini", s.resolved_today, "support-stat-resolved", null]];
  const cat = s.by_category_active || {}; const max = Math.max(1, ...Object.values(cat).map(Number));
  return (
    <div className="mt-5 grid gap-4 xl:grid-cols-[1fr_300px]" data-testid="support-stats">
      <div className="grid gap-3 sm:grid-cols-3 xl:grid-cols-6">
        {cards.map(([l, v, id, tab]) => <button type="button" key={id} onClick={() => tab && onPick(tab)} className={`text-left ${tab ? "cursor-pointer transition-transform hover:-translate-y-0.5" : "cursor-default"}`}><StatCard label={l} value={num(v)} testid={id} accent={id === "support-stat-unread" && v > 0} /></button>)}
      </div>
      <div className="aivora-card p-4" data-testid="support-stat-categories">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Tiket aktif per kategori</p>
        <div className="mt-3 space-y-2">
          {Object.entries(T_CATEGORY).map(([k, l]) => { const v = Number(cat[k] || 0); return (
            <div key={k} className="text-xs"><div className="flex justify-between"><span className="text-slate-700">{l}</span><span className="font-bold text-slate-900">{num(v)}</span></div><div className="mt-1 h-1.5 overflow-hidden rounded-full bg-slate-100"><div className="h-full rounded-full bg-brand transition-all" style={{ width: `${(v / max) * 100}%` }} /></div></div>); })}
        </div>
      </div>
    </div>
  );
}
